module.exports = __webpack_public_path__ + "img/eritrea.ae08238c.svg";